import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import { useForm } from 'react-hook-form';
import { FetchContext } from 'src/context/FetchContext';
import { API_ROUTES } from 'src/services/constant';
import InvoiceCreateForm from './InvoiceCreateForm';
import { Backdrop, CircularProgress } from '@mui/material';

const { PRIVATE_ROUTE } = API_ROUTES;

function InvoiceForm() {
  const { id } = useParams();
  const { authAxios } = useContext(FetchContext);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [initialData, setInitialData] = useState({});
  const [labourCostArr, setLabourCostArr] = useState([]);
  const [taxCodeArr, setTaxCodeArr] = useState([]);
  const [salesTax, setSalesTax] = useState([]);
  const [editData, setEditData] = useState();
  const [defaultInvoiceItemName, setDefaultInvoiceItemName] = useState('');
  const [defaultSalesTaxName, setDefaultSalesTaxName] = useState('');
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
    setValue,
    watch,
    getValues,
    control,
  } = useForm(
    !id
      ? {
        selectClient: '',
        selectClient_id: '',
        taskIds: '',
      }
      : {
        selectClient: '',
        selectClient_id: '',
        taskIds: '',
      }
  );

  useEffect(() => {
    const fetchInvoiceData = async () => {
      try {
        if (id) {
          const invoiceData = await authAxios.get(`${PRIVATE_ROUTE.GET_INVOICE_BY_ID}/${id}`);
          setEditData(invoiceData?.data?.data);
        }
      } catch (error) {
        console.error('Error fetching invoice data:', error);
      }
    };
    fetchInvoiceData();
  }, [id]);

  async function ServicesItem() {
    setLoading(true);

    try {
      const response = await authAxios.get(
        PRIVATE_ROUTE.GET_INVOICE_ITEM_DATA
      );

      console.log('Full invoice item API response:', response.data);

      const data = response?.data?.data ?? response?.data ?? {};
      const itemList = data.ITEMS_LIST ?? data.ITEM_LIST ?? [];
      const taxCodes = data.TAX_CODES_LIST ?? [];

      const defaultItem = data.DEFAULT_INVOICE_ITEM;

      const defaultTax = data.DEFAULT_TAX_CODE;

      const defaultTaxName =
        defaultTax && typeof defaultTax === 'object'
          ? defaultTax.Name ??
          defaultTax.name ??
          defaultTax.sales_tax ??
          ''
          : defaultTax ?? '';

      const defaultItemName =
        defaultItem && typeof defaultItem === 'object'
          ? defaultItem.Name ?? defaultItem.name ?? defaultItem.cost_item ?? ''
          : defaultItem ?? '';

      const labour_arr = itemList.map((item, index) => ({
        index: index + 1,
        cost_item: item?.Name ?? '',
        dwr_hours: 1,
        unit_cost: Number(item?.UnitPrice ?? 0),
        billable_cost: Number(item?.UnitPrice ?? 0),
        value: String(item?.Id ?? ''),
      }));

      setLabourCostArr(labour_arr);
      setDefaultInvoiceItemName(String(defaultItemName));
      setDefaultSalesTaxName(String(defaultTaxName).trim());

      console.log('Default sales tax name:', defaultTaxName);
      setTaxCodeArr(
        taxCodes.filter((item) =>
          ['3', '7', '8'].includes(String(item?.Id))
        )
      );
      setSalesTax(
        taxCodes.filter(
          (item) =>
            (item?.SalesTaxRateList?.TaxRateDetail?.length ?? 0) > 0
        )
      );

      console.log('Default invoice item name:', defaultItemName);
    } catch (error) {
      console.error('Error fetching invoice items:', error);
      setLabourCostArr([]);
      setTaxCodeArr([]);
      setSalesTax([]);
    } finally {
      setLoading(false);
    }
  }

  const getReleventData = useCallback(async () => {
    const taskInitialData = await authAxios.get(`${PRIVATE_ROUTE.GET_CLIENTALL}`);
    setInitialData({
      client: taskInitialData?.data?.data
        ?.filter((item) => item?.active === true)
        .map((iteam) => ({ label: iteam.company_name, id: iteam._id, company_email: iteam.company_email })),
    });
  }, [authAxios]);

  useEffect(() => {
    getReleventData();
    ServicesItem();
  }, [getReleventData]);

  const onSubmit = async (data) => {
    if (data.labourCosts?.length === 0 || !data.labourCosts) {
      const msg = 'Please select atleast one item';
      toast.error(msg);
      return;
    }
    const emptyCostItemsCount = data.labourCosts.filter((item) => item.cost_item === '').length;
    if (emptyCostItemsCount) {
      return toast.error('Please select a cost item from the dropdown.', {
        autoClose: 5000, // 5 seconds
      });
    }

    if (id) {
      const response = await authAxios.post(`${PRIVATE_ROUTE.UPDATE_INVOICE}${id}`, data);
      if (response.data.statusCode === 200) {
        toast.success(response.data.massage);
        navigate('/invoice/list');
      } else {
        toast.error(response.data.massage);
      }
    } else {
      const response = await authAxios.post(PRIVATE_ROUTE?.CREATE_INVOICE, data);
      if (response.data.statusCode === 200) {
        toast.success(response.data.massage);
        navigate('/invoice/list');
      } else {
        toast.error(response.data.massage);
      }
    }
  };

  return (
    <>
      {loading ? (
        <div>
          <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
            <CircularProgress color="inherit" />
          </Backdrop>
        </div>
      ) : (
        ''
      )}
      <InvoiceCreateForm
        initialData={initialData}
        getValues={getValues}
        watch={watch}
        setValue={setValue}
        register={register}
        handleSubmit={handleSubmit}
        errors={errors}
        onSubmit={onSubmit}
        params={id}
        loading={isSubmitting}
        isEdit={id ? 'true' : 'false'}
        control={control}
        labourCostArr={labourCostArr}
        editData={editData}
        setEditData={setEditData}
        taxCodeArr={taxCodeArr}
        salesTax={salesTax}
        defaultInvoiceItemName={defaultInvoiceItemName}
        defaultSalesTaxName={defaultSalesTaxName}
      />
    </>
  );
}

export default InvoiceForm;
